module.exports = __webpack_public_path__ + "media/1alB-b-bex.8fe94a06.mp3";